import DashCard from "../../containers/dashcard";
import Othernav from "../../components/navs/othernav";
import "react-phone-input-2/lib/style.css";
import { useUserContext } from "../../context/userContext";
import { useState } from "react";
import api from "../../utils/axiosConfig";
import { toast } from "react-hot-toast";
import withAuth from "../../components/user/withAuth";
import Group28 from "../../assets/Group 28.svg";
import msg from "../../assets/msg.svg";

const EditProfile = () => {
  const { user } = useUserContext();

  const [firstName, setFirstName] = useState(user?.user?.name.split(" ")[0]);
  const [lastName, setLastName] = useState(user?.user?.name.split(" ")[1]);
  const [email, setEmail] = useState(user?.user?.email);
  const [phoneNumber, setPhoneNumber] = useState(user?.user?.phone);

  const avatarUrl = `https://api.dicebear.com/7.x/identicon/svg?seed=${user?.user?.name}`;

  const handleSave = (e) => {
    e.preventDefault();

    api
      .put("/auth/user", {
        firstName,
        lastName,
        email,
        phone: phoneNumber,
      })
      .then((res) => {
        console.log(res.data);
        toast.success("Profile updated successfully");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  }

  return (
    <div>
      <Othernav headerDetails="Edit Profile" navLink="/account/profile" />
      <DashCard className="max-w-4xl mx-auto p-4 md:mt-40">
        <form>
        <div className="flex flex-col items-center p-4 relative bottom-44 md:bottom-20">
          {/* Profile Image */}
          <div className="relative mb-6">
            <img
              src={avatarUrl}
              alt="User Avatar"
              className="rounded-full w-24 h-24 border border-amber-50 bg-amber-100"
            />
            <button disabled className="absolute bottom-1 right-1 bg-secondary text-white p-1 rounded-full">
              ✏️
            </button>
          </div>

          

          <div className="w-full p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2 w-full">
                <img src={Group28} alt="user-icon" />
                <input
                  type="text"
                  placeholder="First Name"
                  className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4 w-full"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2 w-full">
                <img src={Group28} alt="user-icon" />
                <input
                  type="text"
                  placeholder="Last Name"
                  className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4 w-full"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2 w-full">
                <img src={msg} alt="msg-icon" />
                <input
                  type="text"
                  placeholder="Email Address"
                  className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4 w-full"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2 w-full">
                <span className="text-2xl">🇳🇬</span>
                <input
                  type="text"
                  placeholder="Phone number"
                  className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4 w-full"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>

               {/* Button */}
          <button type="submit" onClick={handleSave} className="w-full mt-6 bg-secondary text-green-400 py-3 rounded-lg hover:bg-green-500 hover:text-white">
            Save changes
          </button>
        </div>
            </div>
            
          </div>

          </form>
      </DashCard>
    </div>
  );
};

const AuthenticatedEdit = withAuth(EditProfile);
export default AuthenticatedEdit;
